import {Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {css} from 'styled-components/native';
import styled from 'styled-components/native';

export const Wrapper = styled.View`
  padding-horizontal: 24px;
`;

export const Card = styled.TouchableOpacity<{cardW: number}>`
  width: ${({cardW}) => cardW}px;
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(12)}px;
  gap: ${RFValue(12)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border2};

  ${({theme}) =>
    Platform.OS === 'ios'
      ? css`
          shadow-color: ${theme.colors.dark_shadow};
          shadow-offset: 0px 2px;
          shadow-opacity: 0.07;
          shadow-radius: 8px;
        `
      : css`

        `}
`;

export const IconBox = styled.View<{bg: string}>`
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(100)}px;
  background-color: ${({bg}) => bg};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const TextArea = styled.View`
  flex: 1;
  gap: ${RFValue(2)}px;
`;

export const Tag = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(9)}px;
  color: #f97316;
  text-transform: uppercase;
  letter-spacing: 0.6px;
`;

export const CardTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const CardDesc = styled.Text`
            font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text};
  line-height: ${RFValue(14)}px;
`;

export const ChevronBox = styled.View`
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;
